/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_SaveInputs */

const en_admin_indexnow_save = /** @type {(inputs: Admin_Indexnow_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save key`)
};

/**
* | output |
* | --- |
* | "Save key" |
*
* @param {Admin_Indexnow_SaveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_save = /** @type {((inputs?: Admin_Indexnow_SaveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_SaveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_save(inputs)
});
export { admin_indexnow_save as "admin.indexnow.save" }